import React from 'react';
import AsyncLoading from '@components/AsyncLoading/AsyncLoading';

const LazyJobDetail = React.lazy(
	() => import(/* webpackChunkName: 'DownloadJobDetail' */ './components')
);

export default () => ({
	path: ':jobId',
	element: <AsyncLoading component={<LazyJobDetail />} />,
});
